"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueRecordsIds = exports.relationsDifference = exports.dependencyValueDifference = exports.hydrateDependencyValue = void 0;
const differenceWith_1 = __importDefault(require("lodash-es/differenceWith"));
const helpers_1 = require("../dependency-relation-field/helpers");
const hydrateDependencyValue = (value, extraData) => {
    var _a, _b;
    const predecessors = (_a = value === null || value === void 0 ? void 0 : value.predecessor) !== null && _a !== void 0 ? _a : [];
    const successors = (_b = value === null || value === void 0 ? void 0 : value.successor) !== null && _b !== void 0 ? _b : [];
    return {
        predecessor: hydrateRelation(predecessors, extraData || {}),
        successor: hydrateRelation(successors, extraData || {}),
    };
};
exports.hydrateDependencyValue = hydrateDependencyValue;
const hydrateRelation = (relations, extraData) => {
    return relations.map((relation) => {
        var _a, _b;
        const records_map = (_a = extraData[relation.application]) !== null && _a !== void 0 ? _a : {};
        const title = (_b = records_map[relation.record]) !== null && _b !== void 0 ? _b : "";
        return {
            ...relation,
            record: {
                id: relation.record,
                title,
            },
        };
    });
};
const dependencyValueDifference = (value1, value2) => {
    var _a, _b, _c, _d;
    const predecessorsDiff = (0, exports.relationsDifference)((_a = value1 === null || value1 === void 0 ? void 0 : value1.predecessor) !== null && _a !== void 0 ? _a : [], (_b = value2 === null || value2 === void 0 ? void 0 : value2.predecessor) !== null && _b !== void 0 ? _b : []);
    const successorsDiff = (0, exports.relationsDifference)((_c = value1 === null || value1 === void 0 ? void 0 : value1.successor) !== null && _c !== void 0 ? _c : [], (_d = value2 === null || value2 === void 0 ? void 0 : value2.successor) !== null && _d !== void 0 ? _d : []);
    return {
        predecessor: predecessorsDiff,
        successor: successorsDiff,
    };
};
exports.dependencyValueDifference = dependencyValueDifference;
const relationsDifference = (relations1 = [], relations2 = []) => {
    return (0, differenceWith_1.default)(relations1, relations2, (relation1, relation2) => relation1.record === relation2.record &&
        relation1.application === relation2.application);
};
exports.relationsDifference = relationsDifference;
const getUniqueRecordsIds = (value) => {
    var _a, _b;
    const relations = [...((_a = value.predecessor) !== null && _a !== void 0 ? _a : []), ...((_b = value.successor) !== null && _b !== void 0 ? _b : [])];
    return (0, helpers_1.getUniqueRelationRecordsIds)(relations);
};
exports.getUniqueRecordsIds = getUniqueRecordsIds;
